import type { InputSource } from '@/types/InputSource.ts';
import { useSourceStore } from '@/stores/SourceStore.ts';
import { useSessionStore } from '@/stores/SessionStore.ts';
import { logger } from '@/lib/logger.ts';

const setInputSourceAction = async (source: InputSource) => {
    const sessionSettingsStore = useSessionStore();
    if (sessionSettingsStore.isInsideWebView) {
        logger.debug(`setInputSourceAction called from inside web view, ignoring`);
        return;
    }

    const hostStore = useSourceStore();
    hostStore.selectedSourceId = source.id;
    hostStore.selectedSourceName = source.name;
    hostStore.lostSourceId = null;
    hostStore.lostSourceName = null;
};

export { setInputSourceAction };
